import { Label } from "@EditArticleContainer/shared/components/EditableTextContainer/types/editableText.types";
import {
  ContingentPaymentItem,
  FinancialTermsMAField,
  MergeAcquisitionTerms,
} from "@EditArticleContainer/shared/types/paragraphContents/contents/financialTermsMAContent.types";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

const toLabels = (labels: unknown): Label[] => (labels ?? []) as Label[];

/** primary 값이 비어있으면 fallback 필드를 사용한다. (둘 다 비면 fallback 그대로 → 빈 값) */
const resolveField = (
  primary: FinancialTermsMAField,
  fallback: FinancialTermsMAField,
): FinancialTermsMAField =>
  (primary.value.at(0)?.text ?? "").trim() !== "" ? primary : fallback;

export const upfrontValueText = (terms: MergeAcquisitionTerms) =>
  terms["Upfront Payment (MA)"].value.at(0)?.text ?? "";

export const upfrontValueLabels = (terms: MergeAcquisitionTerms): Label[] =>
  toLabels(terms["Upfront Payment (MA)"].value.at(0)?.labels);

export const upfrontPricePerShareText = (terms: MergeAcquisitionTerms) =>
  terms["Upfront Price Per Share (MA)"].value.at(0)?.text ?? "";

export const upfrontPricePerShareLabels = (
  terms: MergeAcquisitionTerms,
): Label[] =>
  toLabels(terms["Upfront Price Per Share (MA)"].value.at(0)?.labels);

export const contingentValueText = (item: ContingentPaymentItem) =>
  item["Contingent Payment (MA)"].value.at(0)?.text ?? "";

export const contingentValueLabels = (item: ContingentPaymentItem): Label[] =>
  toLabels(item["Contingent Payment (MA)"].value.at(0)?.labels);

export const contingentPricePerShareText = (item: ContingentPaymentItem) =>
  item["Contingent Price per share (MA)"].value.at(0)?.text ?? "";

export const contingentPricePerShareLabels = (
  item: ContingentPaymentItem,
): Label[] =>
  toLabels(item["Contingent Price per share (MA)"].value.at(0)?.labels);

export const contingentMilestoneText = (item: ContingentPaymentItem) =>
  item["Contingent Milestone (MA)"].value.at(0)?.text ?? "";

export const contingentMilestoneLabels = (
  item: ContingentPaymentItem,
): Label[] => toLabels(item["Contingent Milestone (MA)"].value.at(0)?.labels);

const resolveTotalValueField = (terms: MergeAcquisitionTerms) =>
  resolveField(
    terms["Total Payment (MA)"],
    terms["Disclosed Payments Sum (MA)"],
  );

const resolveTotalPricePerShareField = (terms: MergeAcquisitionTerms) =>
  resolveField(
    terms["Price Per Share"],
    terms["Disclosed Payments Sum Price Per Share (MA)"],
  );

export const totalValueText = (terms: MergeAcquisitionTerms) =>
  resolveTotalValueField(terms).value.at(0)?.text ?? "";

export const totalValueLabels = (terms: MergeAcquisitionTerms): Label[] =>
  toLabels(resolveTotalValueField(terms).value.at(0)?.labels);

export const totalPricePerShareText = (terms: MergeAcquisitionTerms) =>
  resolveTotalPricePerShareField(terms).value.at(0)?.text ?? "";

export const totalPricePerShareLabels = (
  terms: MergeAcquisitionTerms,
): Label[] =>
  toLabels(resolveTotalPricePerShareField(terms).value.at(0)?.labels);

export const numSharesText = (terms: MergeAcquisitionTerms) =>
  terms["Number of acquiring shares"].value.at(0)?.text ?? "";

export const numSharesLabels = (terms: MergeAcquisitionTerms): Label[] =>
  toLabels(terms["Number of acquiring shares"].value.at(0)?.labels);

export const pricePerShareText = (terms: MergeAcquisitionTerms) =>
  terms["Price Per Share"].value.at(0)?.text ?? "";

export const pricePerShareLabels = (terms: MergeAcquisitionTerms): Label[] =>
  toLabels(terms["Price Per Share"].value.at(0)?.labels);

export const ownershipExchangeTermsText = (terms: MergeAcquisitionTerms) =>
  createMultiLineText({
    textList: terms["Merger Financial Terms (MA)"].value.map(
      (item) => item.text ?? "",
    ),
    parseString: (text) => `- ${text.trim()}`,
  });

export const financialTermDetailsText = (terms: MergeAcquisitionTerms) =>
  createMultiLineText({
    textList: terms["Other Financial Terms (MA)"].value.map(
      (item) => item.text ?? "",
    ),
    parseString: (text) => `- ${text.trim()}`,
  });
